// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"106":"a311d10993949aac5767","313":"c18191d01a0dc6b3f3a1","483":"8be71696e371a6ae0ddc","630":"aa6e1584b402509cd582","822":"86cb4a7339ea58c883f6"}[chunkId] + ".bundle.js";
};